import produce from 'immer';
import { BaseTokenInterface } from '../../shared/interfaces/base-token-service.interface';
import { baseAuthActions } from '../actions';
import { UserRegisterCheckResponse } from '../../../api';

export interface BaseAuthState {
  user: {
    data: BaseTokenInterface | undefined;
    ok: boolean | undefined;
  };
  refresh: boolean | undefined;
  isFirstTimeLogin: boolean | undefined;
  isCustomizedUser: boolean | undefined;
  registrationCheck: UserRegisterCheckResponse | undefined;
}

export const BASE_INITIAL_AUTH_STATE: BaseAuthState = {
  user: {
    data: undefined,
    ok: undefined,
  },
  refresh: undefined,
  isFirstTimeLogin: undefined,
  isCustomizedUser: undefined,
  registrationCheck: undefined,
};

export function baseAuthReducer(state: BaseAuthState = BASE_INITIAL_AUTH_STATE, action: any): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Login
      case baseAuthActions.loadToken.type:
        draftState.user.ok = undefined;
        return;
      case baseAuthActions.setUserInfoFromToken.type:
        draftState.user.data = action.payload;
        return;
      case baseAuthActions.successUserInfo.type:
        draftState.user.ok = true;
        return;
      case baseAuthActions.errorUserInfo.type:
        draftState.user.ok = false;
        return;
      case baseAuthActions.refreshUser.type:
        draftState.refresh = undefined;
        return;
      case baseAuthActions.successRefreshUser.type:
        draftState.refresh = true;
        return;
      case baseAuthActions.errorRefreshUser.type:
        draftState.refresh = false;
        return;
      case baseAuthActions.setFirstLoginIndicator.type:
        draftState.isFirstTimeLogin = action.payload;
        return;
      case baseAuthActions.setCustomizedUser.type:
        draftState.isCustomizedUser = action.payload;
        return;
      case baseAuthActions.loadRegistrationCheck.type:
        draftState.registrationCheck = undefined;
        return;
      case baseAuthActions.successLoadRegistrationCheck.type:
        draftState.registrationCheck = action.payload;
        return;
      case baseAuthActions.errorLoadRegistrationCheck.type:
        draftState.registrationCheck = undefined;
        return;
      case baseAuthActions.resetRegistrationCheck.type:
        draftState.registrationCheck = undefined;
        return;
    }
  });
}
